import React, { Component } from 'react'

import classNames from './ChannelDebug.css'

export default class ChannelDebug extends Component {
  renderLog = ({ message, source }) => {
    let className = classNames.log
    if (source === 'frontend') className = classNames.frontend
    if (/^playing/i.test(message)) className = classNames.playing
    if (/^skipped/i.test(message)) className = classNames.skipped
    if (/^skipped due to/i.test(message)) className = classNames.skippedDue
    if (/^skipped\. /i.test(message)) className = classNames.skippedReasons
    if (/^error/i.test(message)) className = classNames.error
    if (/^conflict/i.test(message)) className = classNames.conflict
    return (
      <li className={className}>
        {source}: {message}
      </li>
    )
  }
  render () {
    const { logs } = this.props
    return (
      <div className={classNames.page}>
        <ul>
          {logs.map(this.renderLog)}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/present/ChannelDebug.js